import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@layout/assets/img/company-logo.svg'
import _imports_1 from '@layout/assets/img/company-name.svg'


const _hoisted_1 = { class: "main-navigation__content-overflow" }
const _hoisted_2 = { class: "main-navigation__content-wrapper" }
const _hoisted_3 = { class: "main-navigation__logo-wrapper" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  class: "company-info__logo",
  src: _imports_0,
  alt: "company-logo"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  class: "company-info__name hidden-element",
  src: _imports_1,
  alt: "company-name"
}, null, -1)
const _hoisted_6 = { class: "page-navigation" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-element" }, "Мои модели компетенций", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-element" }, "Каталог моделей", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "hidden-element" }, "Опросники", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("div", { class: "aside-footer__mail" }, [
  /*#__PURE__*/_createTextVNode(" Поддержка: "),
  /*#__PURE__*/_createElementVNode("a", {
    href: "mailto:support@gotalent.ru",
    class: "mail-text"
  }, "support@gotalent.ru")
], -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", { class: "app-name" }, " © GoTalent — оценка компетенций ", -1)
const _hoisted_12 = { class: "btn-hide__icon-wrapper" }

import { inject, computed, ref, onUnmounted } from "vue"
import { useRoute } from "vue-router"
import { Subscription, timer } from "rxjs"
import { reaction } from "mobx"

import { LAYOUT_STORE_KEY, PATH_KEY } from "@global/di/keys"
import { RouterPaths } from "@global/utils/PATHS"
import CatalogModelPageIcon from "@layout/assets/icons/catalog-model-page-icon.vue"
import DropdownIcon from "@layout/assets/icons/dropdown-icon.vue"
import MatrixlistPageIcon from "@layout/assets/icons/matrixlist-page-icon.vue"
import SurveyPageIcon from "@layout/assets/icons/survey-page-icon.vue"
import { TLayoutStoreModel } from "@layout/models"
import { useAuthStore } from "@auth/store/authStore"


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const pathToDocLicenseAgreement = "/docs/Лицензионное_соглашение_GoTalent.pdf"
const pathToDocPrivacyNotice = "/docs/Уведомление_о_приватности_GoTalent.pdf"

const PATHS = inject(PATH_KEY) as RouterPaths
const layoutStore = inject(LAYOUT_STORE_KEY) as TLayoutStoreModel

let hoverTimerSubscription: Subscription | null = null

const navigationIsHoverOpen = ref(false)
const isVisibleSidebarLocal = ref(layoutStore.isVisibleSidebar)

const authStore = useAuthStore()

const route = useRoute()

const isMatrixListPage = computed(() => route.path.startsWith("/matrix-list"))
const isMatrixTemplatesPage = computed(() =>
  route.path.startsWith("/matrix-templates")
)
const isShowOpenShadow = computed(
  () => isVisibleSidebarLocal.value && navigationIsHoverOpen.value
)

const hideHoverNavigation = () => {
  navigationIsHoverOpen.value = false

  hoverTimerSubscription?.unsubscribe()
}

const toggleNavigation = () => {
  layoutStore.toggleSidebarState()

  // Если боковая панель закрывается, но она была открыта по ховеру, то скрываем её
  if (isShowOpenShadow.value) {
    hideHoverNavigation()
  }
}

const showHoverNavigation = () => {
  if (layoutStore.isVisibleSidebar) return

  hoverTimerSubscription = timer(2000).subscribe({
    next: () => {
      hoverTimerSubscription?.unsubscribe()

      // Если за время действия таймера пользователь развернул навигацию кнопкой
      // то не открываем её повторно ховером и не добавляем тень.
      if (!layoutStore.isVisibleSidebar) {
        navigationIsHoverOpen.value = true
      }
    },
  })
}

const visibleSidebarDisposer = reaction<boolean>(
  () => layoutStore.isVisibleSidebar,
  (isVisibleSidebar) => (isVisibleSidebarLocal.value = isVisibleSidebar)
)

onUnmounted(() => {
  visibleSidebarDisposer()
})

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["main-navigation", {
      'main-navigation_hide': !isVisibleSidebarLocal.value,
      'main-navigation_hover-show': navigationIsHoverOpen.value,
      'main-navigation--gray-filter': !_unref(authStore).isMemberOfOrganization,
    }]),
    onMouseenter: showHoverNavigation,
    onMouseleave: hideHoverNavigation
  }, [
    _createElementVNode("div", {
      class: _normalizeClass(["main-navigation__hover-wrapper", {
        'main-navigation_open-shadow': _unref(isShowOpenShadow),
      }])
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createVNode(_component_router_link, {
              to: _unref(PATHS).home,
              class: "company-info"
            }, {
              default: _withCtx(() => [
                _hoisted_4,
                _hoisted_5
              ]),
              _: 1
            }, 8, ["to"])
          ]),
          _createElementVNode("nav", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: _normalizeClass(["page-navigation__item", { 'router-link-active': _unref(isMatrixListPage) }]),
              to: _unref(PATHS).userMatrices,
              "data-cy": `${_unref(PATHS).userMatrices.name}__router-link`
            }, {
              default: _withCtx(() => [
                _createVNode(MatrixlistPageIcon, { class: "page-navigation__icon" }),
                _hoisted_7
              ]),
              _: 1
            }, 8, ["class", "to", "data-cy"]),
            _createVNode(_component_router_link, {
              class: _normalizeClass(["page-navigation__item", { 'router-link-active': _unref(isMatrixTemplatesPage) }]),
              to: _unref(PATHS).matrixTemplates,
              "data-cy": `${_unref(PATHS).matrixTemplates.name}__router-link`
            }, {
              default: _withCtx(() => [
                _createVNode(CatalogModelPageIcon, { class: "page-navigation__icon" }),
                _hoisted_8
              ]),
              _: 1
            }, 8, ["class", "to", "data-cy"]),
            _createVNode(_component_router_link, {
              to: _unref(PATHS).survey,
              "data-cy": `${_unref(PATHS).survey.name}__router-link`,
              class: "page-navigation__item"
            }, {
              default: _withCtx(() => [
                _createVNode(SurveyPageIcon, { class: "page-navigation__icon" }),
                _hoisted_9
              ]),
              _: 1
            }, 8, ["to", "data-cy"])
          ]),
          _createElementVNode("div", { class: "aside-footer hidden-element" }, [
            _hoisted_10,
            _createElementVNode("div", { class: "aside-footer__link-wrapper" }, [
              _createElementVNode("a", {
                class: "link-info-doc",
                href: pathToDocLicenseAgreement,
                target: "_blank"
              }, " Лицензионное соглашение "),
              _createElementVNode("a", {
                class: "link-info-doc",
                href: pathToDocPrivacyNotice,
                target: "_blank"
              }, " Уведомление о приватности ")
            ]),
            _hoisted_11
          ])
        ])
      ]),
      _createElementVNode("button", {
        class: "btn-hide",
        type: "button",
        onClick: toggleNavigation
      }, [
        _createElementVNode("span", _hoisted_12, [
          _createVNode(DropdownIcon, { class: "btn-hide__icon" })
        ])
      ])
    ], 2)
  ], 34))
}
}

})